import PlayerSocket from './utils/PlayerSocket'
import PlayerSync from './utils/PlayerSync'
import PlayerRemote from './utils/PlayerRemote'

export const getRandomColor = () => {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

export const is_touch_device = () => {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}

export const clearSelection = () => {
    if (window.getSelection) { window.getSelection().removeAllRanges(); }
    else if (document.selection) { document.selection.empty(); }
}
  
const Utils =  {
    PlayerSocket,
    PlayerSync,
    PlayerRemote
};

export const pushGTMData = function (label, action, category) {
const yy = 'roiroiroi';
    const gtmData = {
        'GA_event_label': label,
        'GA_event_action': action,
        'GA_event_category': category,
        'event': 'GTM event to GA',
    }

    if (window.dataLayer) {
        dataLayer.push(gtmData);
    }

}

export const pushGTMExtraData = ({eventName, eventText, eventDetail, eventGroup, extraEventDetails}) => {

    const eventDetails = {
      event: "dl_event",
      event_name: eventName,
      event_text: eventText,
      event_detail: eventDetail,
      event_group: eventGroup,
      ...extraEventDetails,
    }
    if (window.dataLayer) 
        window.dataLayer.push(eventDetails)
}

export default Utils; 
